import Article from "~/models/article";
import Page from "./page";
import Label from "./label";

// Type for YAML-based series
export interface YamlSeries {
  id: string;
  slug: string;
  title: string;
  image?: any;
  items?: any[];
  page: any[];
  labels: any[];
}

export default class Series {
  id: string;
  slug: string;
  title: string;
  image: any;
  items: Article[];
  page: Page;
  labels: Label[];

  constructor(series: YamlSeries) {
    this.id = series.id;
    this.slug = series.slug!;
    this.title = series.title!;
    this.image = series.image as any;
    this.items =
      series.items?.map((article: any) => new Article(article!)) || [];
    this.page = new Page(series.page as any);
    this.labels = series.labels?.map((label: any) => new Label(label!)) || [];
  }
}
